export default __webpack_public_path__ + "static/media/s2c1.e4057e6d.jpg";